module.exports = __webpack_public_path__ + "img/dy.c2a4e727.png";